// @keep-mui-icons CheckCircle, Error, Warning — the four toast variants fill
// the same slot one at a time, so they read as one family; the set draws the
// warning but has no error and no circled check, and a lone two-tone drawing
// among three Material ones reads as a broken variant. They move together or
// not at all. The "i" and the cross are held for the whole app (KEPT_ON_MUI).

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
// Named for its origin: WarningIcon is the app set's drawing everywhere else,
// and this is deliberately Material's.
import MuiWarningIcon from '@mui/icons-material/Warning';
import IconButton from '@mui/material/IconButton';

import { StyledIcon, StyledNotistack } from './styles';

import {
  closeSnackbar,
  SnackbarProvider as NotistackProvider,
} from 'notistack';
import { useRef } from 'react';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {
  // biome-ignore lint/suspicious/noExplicitAny: any needed here
  const notistackRef = useRef<any>(null);

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      variant="success" // Set default variant
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <InfoIcon />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <CheckCircleIcon />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <MuiWarningIcon />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <ErrorIcon />
          </StyledIcon>
        ),
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack,
      }}
      // with close as default
      action={(snackbarId) => (
        <IconButton
          size="small"
          onClick={() => closeSnackbar(snackbarId)}
          sx={{ p: 0.5 }}
        >
          <CloseIcon />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
}
